import { buildReport, downloadJson } from "../lib/export";
import type { ParsedTsr } from "../lib/parse";
import type { VerificationResult } from "../lib/verify";

export function ExportBar({
  fileName,
  parsed,
  verification,
}: {
  fileName: string;
  parsed: ParsedTsr;
  verification: VerificationResult | null;
}) {
  return (
    <div className="export-bar">
      <button
        type="button"
        onClick={() =>
          downloadJson(
            `${fileName.replace(/\.[^.]+$/, "")}-report.json`,
            buildReport(fileName, parsed, verification)
          )
        }
      >
        Export JSON report
      </button>
      <button type="button" className="ghost" onClick={() => window.print()}>
        Print summary
      </button>
    </div>
  );
}
